import { PERMISSION_PAGE } from "routes/route.constant";
import Permission from "./Permission";

const route = {
  path: PERMISSION_PAGE,
  element: Permission,
};

export default route;
